import './POIs.css';
import React, { useEffect, useState, useRef, useContext } from 'react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { injectImageResolution, pathJoin, getMediaHost, getListingItemURL, generatrURLFromTags, getFeaturedItemAndList, getColorByTheme, canUseDOM, getPageThemeColors } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get, getTags, getDictionaryItem } from '../../utils';
import { formatTagsRuleToFilters, generateSeeMoreTagsFromRules, formatTagsRuleToFiltersOneByOne, isTagsRule } from '../../utils/getListing';
import CuratorPicks from '../atoms/CuratorPicks/CuratorPicks';
//resource
import { useInView } from 'react-intersection-observer';
import getListing, { loadCategoryAlgoliaResults } from '../../utils/getListing';
import FavouriteBtn from '../atoms/FavouriteBtn/FavouriteBtn';
import LazyPicture from '../atoms/LazyPicture';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import RouterLink from '../atoms/RouterLink/RouterLink';
import TripAdvisor from '../atoms/TripAdvisor/TripAdvisor';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import ScrollAnimation from 'react-animate-on-scroll';
import { resolveListPersonalization } from '../../utils/resolveListPersonalization';
import { algoliaScoredCondition } from '../../utils/algoliaScoredCondition';
import { usePersonalizedList } from '@uniformdev/personalize-react';
const imageAnimationDuration = 0.7;
const delayFactor = 500;
const renderImage = (_ref, key) => {
  let {
    image,
    alt,
    className,
    width,
    height: heigth,
    itemUrl,
    useEmptyPlaceholder = true,
    analyticsClick
  } = _ref;
  if (!image) return null;
  const imgSrc = injectImageResolution(`${pathJoin([getMediaHost(), image])}`, width, heigth);
  return /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    className: "poi__a",
    href: itemUrl,
    "aria-label": alt,
    onClick: () => {
      if (analyticsClick) analyticsClick();
    }
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    key: key,
    useEmptyPlaceholder: useEmptyPlaceholder,
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: className,
    src: imgSrc,
    alt: alt
  })));
};
export const POIBlock = _ref2 => {
  let {
    item,
    curatorsCopy,
    callback,
    analytics,
    index = 0,
    hostLink,
    dictionary,
    isListing = false
  } = _ref2;
  const curators = get(item, 'curators.curators');
  const tripAdvRatingImage = get(item, 'tripadvisorImage');
  const tripAdvScore = get(item, 'tripadvisorscore');
  const mainTripadvisorReviews = get(item, 'tripadvisorReviews');
  const mainTripadvisorPrice = get(item, 'tripadvisorPrice');
  const {
    bannerClickAnalytics,
    titleClickAnalytics,
    addToFavAnalytics,
    smallBannerClickAnalytics,
    params
  } = analytics;
  return /*#__PURE__*/React.createElement("div", {
    className: "poi__item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "poi__image-wrap"
  }, item && renderImage({
    image: item.image,
    className: 'poi__image',
    alt: item.title,
    height: 243,
    width: 340,
    itemUrl: getListingItemURL(hostLink, item.urlSlug, item.url),
    analyticsClick: () => tealiumClickFunc(tealiumMergeClickData(bannerClickAnalytics, params), item.englishTitle)
  })), /*#__PURE__*/React.createElement("div", {
    className: "poi__info"
  }, /*#__PURE__*/React.createElement(CuratorPicks, {
    curators: curators,
    copy: curatorsCopy,
    analytics: {
      smallBannerClickAnalytics,
      params,
      name: item.englishTitle
    }
  }), item && item.category && /*#__PURE__*/React.createElement("div", {
    className: "poi__text-sight"
  }, item && item.category && item.category.join(', ')), item && item.url && /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    className: "poi__item-title",
    href: item && getListingItemURL(hostLink, item.urlSlug, item.url),
    onClick: () => tealiumClickFunc(tealiumMergeClickData(titleClickAnalytics, params), item.englishTitle)
  }, item && item.title), /*#__PURE__*/React.createElement("p", {
    className: "body-small poi__text"
  }, item && item.introText), /*#__PURE__*/React.createElement(TripAdvisor, {
    imageRatingSRC: tripAdvRatingImage,
    score: tripAdvScore,
    alt: "Tripadvisor",
    tripadvisorReviews: mainTripadvisorReviews,
    tripadvisorPrice: mainTripadvisorPrice,
    reviewCaption: dictionary
  }), /*#__PURE__*/React.createElement(FavouriteBtn, {
    callback: callback,
    itemId: item && item.objectID,
    componentPrimaryColor: 'var(--m34-pois-background-color)',
    componentPrimaryColorActive: "var(--m34-pois-background-active-color)",
    checkFavouriteButton: item && item.objectID,
    classes: 'poi_fav-btn',
    analyticsClick: e => tealiumClickFunc(tealiumMergeClickData(addToFavAnalytics, params), `${e}: ${item.englishTitle}`),
    isListing: true
  })));
};
const POIs = _ref3 => {
  let {
    fields,
    params,
    route,
    rendering,
    uid
  } = _ref3;
  const [relatedItems, setItem] = useState([]);
  const [mainItem, setMainItem] = useState({});
  const moveToFirstButton = useRef(null);
  const contextItemTags = get(fields, 'data.contextItem.tags.values') || [];
  const datasourceTags = get(fields, 'data.datasource.tags.values') || [];
  const moduleDictionary = get(fields, 'data.moduleDictionary');
  const defaultTitle = getDictionaryItem(moduleDictionary, 'PoisTitle');
  const isInteractive = get(fields, 'data.datasource.interactive.jss.value');
  const tabClickAnalytics = get(fields, 'data.tabClickAnalytics');
  //Context Sitecore
  const sitecoreContext = useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const contextTags = getTags(get(fields, 'data.contextItem.tags'));
  const locationTag = get(fields, 'data.datasource.locationTag.items') || [];
  const theme = get(sitecoreContext, 'themesOfPage');
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const [isVdsite, setIsVdsite] = React.useState(true);
  const ThemeBased = params !== undefined && params['Background Color'] === 'Theme Based' ? true : false;
  const GreyTheme = params !== undefined && params['Background Color'] === 'Grey' ? true : false;
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const selectedPrimaryActiveColor = primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active;
  const renderingId = uid || get(rendering, 'uid') || 'pois-rendering-id';
  useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const currentPageID = get(route, 'itemId', '').split('-').join('');
  const ColorHex = get(params, 'ColorHex');
  const primaryColor = BackgroundColorHex ? BackgroundColorHex : selectedPrimaryColor;
  const color = BackgroundColorHex ? ColorHex : getColorByTheme(selectedPrimaryColor);
  const activeColor = BackgroundColorHex ? ActiveColorHex : selectedPrimaryActiveColor;
  const styleThemeHexColor = ThemeBased ? {
    '--m34-pois-container-background-color': BackgroundColorHex ? BackgroundColorHex : primaryColor,
    '--m34-pois-hex-color': color,
    '--m34-pois-btn-hex-color': color,
    '--m34-pois-dots-hex-color': color,
    '--m34-pois-arrow-hex-color': activeColor,
    '--m34-pois-background-color': primaryColor,
    '--m34-pois-background-active-color': activeColor,
    '--m34-pois-text-color': color
  } : {
    '--m34-pois-container-background-color': GreyTheme ? '#EEEEEF' : '#fff',
    '--m34-pois-hex-color': '#000',
    '--m34-pois-btn-hex-color': primaryColor,
    '--m34-pois-dots-hex-color': '#505050',
    '--m34-pois-arrow-hex-color': primaryColor,
    '--m34-pois-background-color': primaryColor,
    '--m34-pois-background-active-color': activeColor,
    '--m34-pois-text-color': color
  };
  const dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  const showFeatured = get(fields, 'data.datasource.showFeatured.jss.value');
  const searchCount = showFeatured && !isInteractive ? 5 : Number(get(params, 'SearchCount'));
  const useCustomListingPage = get(fields, 'data.datasource.useCustomListingPage.jss.value');
  const considerPageLevelTags = get(fields, 'data.datasource.considerPageLevelTags.jss.value');
  const listingPageLink = useCustomListingPage ? get(fields, 'data.datasource.listingPageLink.jss.url') : get(fields, 'data.overviewButton.link.jss.value.href');
  const overviewButton = get(fields, 'data.overviewButton.title.jss');
  const overviewLink = get(fields, 'data.overviewButton.link.jss.value.href');
  const contextItemId = get(fields, 'data.contextItem.id');
  let curtorListingPage = '';
  if (contextItemId) {
    curtorListingPage = `?curators.curators.Id=${contextItemId}`;
  }
  const title = get(fields, 'data.datasource.title.jss') || {
    value: defaultTitle
  };
  const map = dictionaryValues.reduce((aggregator, currentValue) => aggregator.set(currentValue.key.jss.value, currentValue.phrase.jss.value), new Map());
  const {
    bannerClickAnalytics,
    titleClickAnalytics,
    navBubblesAnalytics,
    prevNextNavAnalytics,
    addToFavAnalytics,
    readMoreAnalytics,
    mobileSlidesAnalytics,
    smallBannerClickAnalytics
  } = fields.data;
  const allText = map.get('All') || '';
  let tagsValues = get(fields, 'data.datasource.tags.values') || [];
  if (tagsValues.length === 0) {
    tagsValues = get(fields, 'data.contextItem.tags.values');
  }
  const tags = tagsValues ? tagsValues.map(tag => {
    return {
      value: get(tag, 'title.jss.value'),
      name: tag.name,
      id: tag.id
    };
  }) : [];
  if (tags.length > 0) tags.unshift({
    value: allText,
    name: allText,
    id: `${renderingId}-all-values-id`
  });
  const curators = get(mainItem, 'curators.curators');
  const mainTripAdvisorRating = get(mainItem, 'tripadvisorImage');
  const mainTripAdvisorScore = get(mainItem, 'tripadvisorScore');
  const mainTripadvisorReviews = get(mainItem, 'tripadvisorReviews');
  const mainTripadvisorPrice = get(mainItem, 'tripadvisorPrice');
  let locationTagArray = locationTag.map(item => {
    const tag = get(item, 'name.jss.value');
    return `location:${tag}`;
  });
  const [tagState, setTagState] = useState(`tags:All`);
  const [ref, inView] = useInView({
    threshold: 1,
    triggerOnce: true
  });
  const actualSSR = process.env.STORYBOOK_MODE ? false : sitecoreContext.route && sitecoreContext.route.fromSSR;
  const isMobile = React.useMemo(() => {
    return !actualSSR && canUseDOM && window.matchMedia(`(max-width: 991px)`).matches;
  }, [actualSSR]);
  const itemTags = get(fields, 'data.datasource') ? getTags(get(fields, 'data.datasource.tags')) : contextTags;
  const indexName = get(params, 'SearchIndex');
  const showCarouselOnMobile = get(fields, 'data.datasource.showCarouselOnMobile.jss.value');
  const [seeMoreURLTags, setSeeMoreURLTags] = React.useState('');
  const isPersonalised = get(sitecoreContext, 'isPersonalised');
  const [validateItems, setValidateItems] = React.useState([]);
  const tagsRule = get(fields, 'data.datasource.tagsRule.jss.value');
  const isTagsRuleUsed = isTagsRule(tagsRule);
  const tagsList = isTagsRuleUsed ? generateSeeMoreTagsFromRules(tagsRule) : considerPageLevelTags ? [...contextItemTags, ...datasourceTags] : [...datasourceTags];
  const intents = get(fields, 'data.datasource.intents');
  const intentsLength = get(intents, 'targetItems.length');
  const contextItem = get(fields, 'data.contextItem');

  // Resolve used conditions based on what is selected with the integrated query
  const conditions = resolveListPersonalization(intents, sitecoreContext);

  // Holder for all condition values
  const allValues = [];

  // Iterate all conditions and determine what the current user is tagged with.
  conditions && Array.isArray(conditions) && conditions.forEach(condition => {
    const {
      handler,
      mappings
    } = condition;
    const conditionValues = handler.getValues({
      mappings,
      sitecoreContext
    });
    if (conditionValues) {
      allValues.push(...conditionValues);
    }
  });
  const {
    personalizedList,
    refreshTracking
  } = usePersonalizedList({
    rendering: contextItem,
    route,
    list: relatedItems,
    conditions: [algoliaScoredCondition(allValues)]
  });
  useEffect(() => {
    setValidateItems(isPersonalised && intentsLength ? personalizedList : relatedItems);
  }, [relatedItems, personalizedList]);
  useEffect(() => {
    if (inView) {
      setSeeMoreURLTags(generatrURLFromTags(tagsList));
      if (isPersonalised && intentsLength) {
        if (locationTagArray.length === 0) {
          (async () => {
            const tags = isTagsRuleUsed ? formatTagsRuleToFilters(tagsRule) : considerPageLevelTags ? [...contextTags, ...itemTags] : itemTags;
            const hits = await loadCategoryAlgoliaResults(allValues || [], algoliaSettings, 'type:POI', searchCount, tags, [contextItemId ? `curators.curators.Id:${contextItemId}` : ''], currentPageID ? `NOT objectID:${currentPageID}` : '', indexName);
            // setResults(hits);
            if (showFeatured && !isInteractive) {
              const featuredItemList = hits ? getFeaturedItemAndList(hits) : {};
              setItem(featuredItemList.list);
              setMainItem(featuredItemList.featured || {});
            } else {
              setItem(hits);
            }
            refreshTracking();
          })();
        } else {
          (async () => {
            const hits = await loadCategoryAlgoliaResults(allValues || [], algoliaSettings, 'type:POI', searchCount, [...locationTagArray], [], currentPageID ? `NOT objectID:${currentPageID}` : '', indexName);
            // setResults(hits);
            const featuredItemList = hits ? getFeaturedItemAndList(hits) : {};
            setItem(featuredItemList.list);
            setMainItem(featuredItemList.featured || {});
            refreshTracking();
          })();
        }
      } else {
        let tags = tagState === 'tags:All' ? considerPageLevelTags ? [...contextTags, ...itemTags] : itemTags : [tagState];
        let facetFilters = [['type:POI'], [...locationTagArray], [contextItemId ? `curators.curators.Id:${contextItemId}` : '']];
        let tagsFromRules = tagState === 'tags:All' ? formatTagsRuleToFiltersOneByOne(tagsRule, facetFilters) : [...facetFilters, ...[tagState]];
        let itemFilter = {
          hitsPerPage: searchCount,
          facetFilters: isTagsRuleUsed ? tagsFromRules : [...facetFilters, ...[tags]],
          filters: currentPageID ? `NOT objectID:${currentPageID}` : ''
        };
        let results = [];
        getListing(indexName, itemFilter, algoliaSettings).then(hits => {
          if (showFeatured && !isInteractive) {
            const featuredItemList = hits.hits ? getFeaturedItemAndList(hits.hits) : {};
            setItem(featuredItemList.list);
            results = [...featuredItemList.list];
            setMainItem(featuredItemList.featured || {});
          } else {
            setItem(hits.hits);
            results = [...hits.hits];
          }
          if (hits && hits.hits.length !== searchCount) {
            getListing(indexName, {
              hitsPerPage: searchCount - hits.hits.length,
              facetFilters: showFeatured ? [['type:POI'], ['featured: true']] : [['type:POI']]
            }, algoliaSettings).then(extraPOIs => {
              const finalResults = [...results, ...extraPOIs.hits];
              const featuredItemList = finalResults ? getFeaturedItemAndList(finalResults) : {};
              setItem(featuredItemList.list);
              setMainItem(featuredItemList.featured || {});
            });
          }
        });
      }
    }
  }, [tagState, currentPageID, inView, isPersonalised]);
  const onFilterChange = (facetType, currentTag) => {
    setTagState(facetType + currentTag);
  };
  const renderTags = poiFormId => {
    if (!tags) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
    return tags.map((tag, index) => {
      let facetType = 'tags:';
      let currentTag = tag;
      if (index === 0) {
        currentTag.value = 'All';
      }
      const animationFactor = 0.2;
      const uniqueId = `poi-${tag.id}`;
      return /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        key: uniqueId,
        duration: 1 + animationFactor * index
      }, /*#__PURE__*/React.createElement("div", {
        className: "poi-checkbox__item",
        onClick: () => {
          handleTagClick(currentTag, facetType);
        }
      }, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        id: uniqueId,
        value: index === 0 ? 'tags:All' : facetType + tag.value,
        name: poiFormId,
        tabIndex: 0,
        checked: facetType + tag.value === tagState,
        onChange: () => setTagState(facetType + currentTag.value)
      }), /*#__PURE__*/React.createElement("label", {
        className: "body-small poi-checkbox__label",
        htmlFor: uniqueId
      }, /*#__PURE__*/React.createElement("span", {
        className: `poi-checkbox__label-text`
      }, tag.value === 'All' ? allText : tag.value))));
    });
  };
  const handleTagClick = (value, facetType) => {
    if (tagState !== facetType + value.value) {
      // if tag is changed
      if (moveToFirstButton.current) {
        moveToFirstButton.current.click();
      }
    }
    tealiumClickFunc(tealiumMergeClickData(tabClickAnalytics, params), `${value.name}`);
  };
  const renderFeaturedItem = () => {
    if (mainItem.url && mainItem.urlSlug) {
      return /*#__PURE__*/React.createElement("div", {
        className: ['poi__featured-block poi__featured-block--highlighted', theme ? ' brand-bd' : '', 'theme-contrast'].join(' ')
      }, /*#__PURE__*/React.createElement(ScrollAnimation, {
        className: "poi__featured__bg-animate",
        animateIn: "animate__slideInRight",
        animateOnce: true,
        duration: 1,
        offset: 150
      }, /*#__PURE__*/React.createElement("div", {
        className: `poi__featured__bg-color`
      })), renderTitle(), /*#__PURE__*/React.createElement("div", {
        className: "col-md-12 col-xl-12 poi__featured-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "poi-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-md-5 col-lg-5 col-xl-6 poi__featured-image-col"
      }, /*#__PURE__*/React.createElement("div", {
        className: "poi__featured-image-wrap"
      }, mainItem && /*#__PURE__*/React.createElement(RouterLink, {
        openInSameTab: true,
        className: "poi__a",
        "aria-label": mainItem.title,
        href: getListingItemURL(overviewLink + curtorListingPage, mainItem.urlSlug, mainItem.url),
        onClick: () => tealiumClickFunc(tealiumMergeClickData(bannerClickAnalytics, params), mainItem.englishTitle)
      }, /*#__PURE__*/React.createElement(LazyPicture, {
        useEmptyPlaceholder: true,
        hover: true
      }, /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 480px)",
        srcSet: injectImageResolution(`${pathJoin([getMediaHost(), mainItem.image])}`, 720, 460)
      }), /*#__PURE__*/React.createElement("img", {
        className: "poi__featured-image",
        src: injectImageResolution(`${pathJoin([getMediaHost(), mainItem.image])}`, 460, 460),
        alt: mainItem.title
      }))))), /*#__PURE__*/React.createElement("div", {
        className: "col-md-0 col-xl-1"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-md-6 col-lg-6 col-xl-5 poi__featured-info-col"
      }, /*#__PURE__*/React.createElement("div", {
        className: "poi__info"
      }, /*#__PURE__*/React.createElement(CuratorPicks, {
        curators: curators,
        copy: map.get('CuratorsPick') || '',
        analytics: {
          smallBannerClickAnalytics,
          params,
          name: mainItem.englishTitle
        }
      }), /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1
      }, /*#__PURE__*/React.createElement("div", {
        className: "poi__text-sight"
      }, /*#__PURE__*/React.createElement("span", null, mainItem && mainItem.category && mainItem.category.join(', ')))), /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1.05
      }, /*#__PURE__*/React.createElement(RouterLink, {
        openInSameTab: true,
        className: "poi__item-title",
        href: mainItem && mainItem.url,
        onClick: () => tealiumClickFunc(tealiumMergeClickData(titleClickAnalytics, params), mainItem.englishTitle)
      }, /*#__PURE__*/React.createElement("span", null, mainItem && mainItem.title))), /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1.1
      }, /*#__PURE__*/React.createElement("p", {
        className: "body-small poi__text"
      }, mainItem && mainItem.introText)), /*#__PURE__*/React.createElement("div", {
        className: "poi__push-bottom"
      }, /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1.15
      }, /*#__PURE__*/React.createElement("div", {
        className: "TripAdvisor-wrapper"
      }, /*#__PURE__*/React.createElement(TripAdvisor, {
        imageRatingSRC: mainTripAdvisorRating,
        score: mainTripAdvisorScore,
        alt: "Tripadvisor",
        tripadvisorReviews: mainTripadvisorReviews,
        tripadvisorPrice: mainTripadvisorPrice,
        reviewCaption: getDictionaryItem(moduleDictionary, 'reviews')
      }))), /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1.15
      }, /*#__PURE__*/React.createElement(FavouriteBtn, {
        itemId: mainItem && mainItem.objectID,
        classes: 'poi_fav-btn',
        componentPrimaryColor: 'var(--m34-pois-background-color)',
        componentPrimaryColorActive: "var(--m34-pois-background-active-color)",
        analyticsClick: e => tealiumClickFunc(tealiumMergeClickData(addToFavAnalytics, params), `${e}: ${mainItem.englishTitle}`),
        isListing: true
      }))))))));
    } else {
      return renderTitle();
    }
  };
  const renderCarouselItems = (tileItems, hostLink) => {
    if (!tileItems || tileItems.length === 0) {
      return [];
    }
    return tileItems.slice(0, searchCount).map((item, index) => {
      return /*#__PURE__*/React.createElement(ScrollAnimation, {
        className: "poi__animate-item",
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1 + index / 2,
        key: `tile-item-${index}`
      }, /*#__PURE__*/React.createElement(POIBlock, {
        item: item,
        curatorsCopy: map.get('CuratorsPick'),
        key: index,
        hostLink: hostLink,
        dictionary: getDictionaryItem(moduleDictionary, 'reviews'),
        analytics: {
          bannerClickAnalytics,
          titleClickAnalytics,
          navBubblesAnalytics,
          prevNextNavAnalytics,
          addToFavAnalytics,
          readMoreAnalytics,
          mobileSlidesAnalytics,
          params
        }
      }));
    });
  };
  const renderTitle = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: "poi__title-block"
    }, /*#__PURE__*/React.createElement(ScrollAnimation, {
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1
    }, /*#__PURE__*/React.createElement(Text, {
      tag: "h2",
      className: "poi__title poi__title--no-featured",
      field: title
    })));
  };
  const renderTitleInteractive = poiFormId => {
    return /*#__PURE__*/React.createElement(ScrollAnimation, {
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1
    }, /*#__PURE__*/React.createElement("div", {
      className: "poi__title-block"
    }, /*#__PURE__*/React.createElement(Text, {
      tag: "h2",
      className: "poi__title poi__title--no-featured",
      field: title
    }), isInteractive && !!tags && !!tags.length && /*#__PURE__*/React.createElement("div", {
      className: "row poi__filters-block"
    }, /*#__PURE__*/React.createElement("div", {
      className: `poi-checkbox poi-checkbox--mob-scroll ${theme ? 'brand-checkbox' : ''}`
    }, /*#__PURE__*/React.createElement("form", {
      id: poiFormId
    }, /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", {
      hidden: true
    }, defaultTitle), renderTags(poiFormId)))))));
  };
  const showFeatureCondition = !isInteractive && mainItem.objectID && showFeatured;
  const renderCarouselFilteredItem = (isInteractive, hostLink) => {
    let items = isPersonalised && intentsLength ? personalizedList : relatedItems;
    const poiFormId = `poi-checkbox-${Math.floor(Math.random() * 100)}`;
    if (items && items.length >= 5 || items && items.length > 0 && items.length < 5 && isMobile && showCarouselOnMobile) {
      return /*#__PURE__*/React.createElement(CarouselProvider, null, _ref4 => {
        let {
          renderCarousel,
          renderPreviousButton,
          renderNextButton,
          renderDots
        } = _ref4;
        return /*#__PURE__*/React.createElement(React.Fragment, null, !showFeatureCondition && /*#__PURE__*/React.createElement("div", {
          className: "poi-pagination__btn-wrapper"
        }, renderTitleInteractive(poiFormId), /*#__PURE__*/React.createElement("div", {
          className: `poi-pagination__btn ${rtl ? 'btn-group-rtl' : ''}`
        }, renderPreviousButton(() => tealiumClickFunc(tealiumMergeClickData(prevNextNavAnalytics, params), 'Previous')), renderNextButton(() => tealiumClickFunc(tealiumMergeClickData(prevNextNavAnalytics, params), 'Next')))), renderCarousel(renderCarouselItems(items, hostLink), {
          responsive: {
            desktop: {
              breakpoint: {
                max: 10000,
                min: 1440
              },
              items: 4
            },
            laptop: {
              breakpoint: {
                max: 1440,
                min: 1280
              },
              items: 3
            },
            tablet_landscape: {
              breakpoint: {
                max: 1280,
                min: 768
              },
              items: 2
            },
            tablet: {
              breakpoint: {
                max: 767,
                min: 560
              },
              items: 2
            },
            mobile: {
              breakpoint: {
                max: 560,
                min: 0
              },
              items: 1
            }
          }
        }), /*#__PURE__*/React.createElement("div", {
          className: "poi-pagination__dots"
        }, /*#__PURE__*/React.createElement(ScrollAnimation, {
          className: "poi-dots-wrapper__fadeInUp",
          animateIn: "animate__fadeInUp",
          animateOnce: true,
          duration: 1,
          delay: 200
        }, /*#__PURE__*/React.createElement("div", {
          className: "article__link"
        }, overviewButton && /*#__PURE__*/React.createElement(ScrollAnimation, {
          animateIn: "animate__fadeInUp",
          animateOnce: true,
          duration: 1.5
        }, /*#__PURE__*/React.createElement("div", {
          className: "poi__more-bar"
        }, /*#__PURE__*/React.createElement(RouterLink, {
          openInSameTab: true,
          className: "btn btn-secondary btn-mob",
          href: listingPageLink + curtorListingPage + seeMoreURLTags,
          onClick: () => tealiumClickFunc(tealiumMergeClickData(readMoreAnalytics, params))
        }, overviewButton.value))))), renderDots(() => tealiumClickFunc(tealiumMergeClickData(navBubblesAnalytics, params)))));
      });
    }
    if (items && items.length > 0 && items.length < 5) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, !showFeatureCondition && renderTitleInteractive(poiFormId), /*#__PURE__*/React.createElement("div", {
        className: `pois__items`
      }, renderCarouselItems(items, hostLink)), overviewButton && /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1.5
      }, /*#__PURE__*/React.createElement("div", {
        className: "poi__more-bar margin-top"
      }, /*#__PURE__*/React.createElement(RouterLink, {
        openInSameTab: true,
        className: "btn btn-secondary btn-mob",
        href: listingPageLink + curtorListingPage + seeMoreURLTags,
        onClick: () => tealiumClickFunc(tealiumMergeClickData(readMoreAnalytics, params))
      }, overviewButton.value))));
    }
    if (isInteractive && (!items || items.length <= 0)) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, !showFeatureCondition && renderTitleInteractive(poiFormId), /*#__PURE__*/React.createElement("div", {
        className: "message-no-item rs_skip"
      }, /*#__PURE__*/React.createElement("span", null, map.get('ItemsNotFound'))));
    }
    return null;
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    styleThemeHexColor: styleThemeHexColor,
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: `${showCarouselOnMobile ? 'show-carousel-mobile' : 'hide-carousel-mobile'}`
  }, showFeatureCondition && renderFeaturedItem(), /*#__PURE__*/React.createElement("div", {
    className: 'row pois__items-row'
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, renderCarouselFilteredItem(isInteractive, overviewLink + curtorListingPage)))));
};
const StyledWrapper = _ref5 => {
  let {
    children,
    rtl,
    anchorUrlParameter,
    styleThemeHexColor
  } = _ref5;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: `${poiStyle} ${rtl ? rtlStyles : ltrStyles}  ${ColorsLogic}`,
    style: styleThemeHexColor
  }, children);
};
const ColorsLogic = "c1vy3kw9";
const poiStyle = "phis2rz";
const ltrStyles = "l1k8w2a6";
const rtlStyles = "rv2wvvo";
export default POIs;